import React from 'react';
import PropTypes from 'prop-types';

import { formatShelfLife, isInDays } from 'apps/products/utils/shelfLife';
import msg from 'msg';

const ExpiryDate = (props) => {
  const { averageShelfLife, minimumShelfLife } = props;

  if (!minimumShelfLife) { return null; }

  const { productsExpirationDate: { minimumShelfLifeIsInDays, defaultText } } = msg;
  const formattedMinimumShelfLife = formatShelfLife(minimumShelfLife);

  if (isInDays(minimumShelfLife)) {
    return (
      <p className="bop-expiryDate__long">
        {minimumShelfLifeIsInDays(formattedMinimumShelfLife, averageShelfLife, minimumShelfLife)}
      </p>
    );
  }

  return (
    <p className="bop-expiryDate__long">
      {defaultText(formattedMinimumShelfLife, averageShelfLife, minimumShelfLife)}
    </p>);
};

ExpiryDate.propTypes = {
  minimumShelfLife: PropTypes.number.isRequired,
  averageShelfLife: PropTypes.number,
};

export default ExpiryDate;
